// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ControlledFormDatePicker__datePickerContainer___WxkKM .ControlledFormDatePicker__inputsContainer___WpqCh{display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./src/shared/components/formInputs/ControlledFormDatePicker.scss"],"names":[],"mappings":"AACE,0GACE,YAAA,CACA,qBAAA","sourcesContent":[".datePickerContainer {\n  .inputsContainer {\n    display: flex;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"datePickerContainer": "ControlledFormDatePicker__datePickerContainer___WxkKM",
	"inputsContainer": "ControlledFormDatePicker__inputsContainer___WpqCh"
};
export default ___CSS_LOADER_EXPORT___;
